import type { PropsWithChildren } from 'react';
import { useFaq } from './Faq';
import { useFaqItem } from './FaqItem';
import { Icon } from '../Icon';
import clsx from 'clsx';

type FaqItemHeaderProps = PropsWithChildren;

export const FaqItemHeader = ( { children }: FaqItemHeaderProps ) => {
  const { openItemId, setOpenItemId } = useFaq();
  const { id } = useFaqItem();

  return (
    <div
      className={ 'px-5 py-2.5 cursor-pointer grid grid-cols-[1fr_min-content] gap-x-5' }
      onClick={ () => {
        setOpenItemId( openItemId === id ? '' : id )
      } }>
      { children }
      <Icon
        name={ 'chevron-down' }
        className={ clsx( 'transition-transform duration-300', {
          'rotate-180': id === openItemId
        } ) }
      />
    </div>
  )
}
FaqItemHeader.displayName = 'FaqItemHeader';
